const getValueIndex = (text) => {
    let startIndex = null;
    let endIndex = null;

    for (let i = 0; i < text.length; i++) {
        const letter = text[i];
        if (letter === '[') startIndex = i;
        if (letter === ']') endIndex = i;
    }

    return {
        startIndex,
        endIndex,
    };
};

export const getMaxValue = (text) => {
    const { startIndex, endIndex } = getValueIndex(text);

    if (startIndex !== null && endIndex !== null) {
        const endValueS = text.slice(startIndex + 1, endIndex);
        return Number(endValueS);
    }

    return Number(text) || 0;
};

export const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

const renderValue = (text, value) => {
    const { startIndex, endIndex } = getValueIndex(text);

    if (startIndex !== null && endIndex !== null) {
        return (
            text.substr(0, startIndex) + formatNumber(Math.round(value)) + text.substr(endIndex + 1, text.length - 1)
        );
    } else {
        const numberOnlyValue = Number(text);
        if (numberOnlyValue) {
            return formatNumber(Math.round(value));
        }
    }

    return text;
};

export default renderValue;
